import { useEffect, useRef, useState } from "react";

export default function useIsTruncated(label: string | undefined) {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isTextTruncated, setIsTextTruncated] = useState(false);

  useEffect(() => {
    if (!label) {
      setIsTextTruncated(false);
      return;
    }

    function checkTruncation() {
      if (textRef.current) {
        const isOverflowing =
          textRef.current.scrollWidth > textRef.current.clientWidth;
        setIsTextTruncated(isOverflowing);
      }
    }

    checkTruncation();
    window.addEventListener("resize", checkTruncation);
    return () => {
      window.removeEventListener("resize", checkTruncation);
    };
  }, [label]);

  return {
    textRef,
    isTextTruncated,
  };
}
